'use client'

import { Trans } from '@lingui/react/macro'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined'

interface RecordingConsentDialogProps {
  onAccept: () => void
  onRefuse: () => void
}

export function RecordingConsentDialog({ onAccept, onRefuse }: RecordingConsentDialogProps) {
  return (
    <Dialog open disableEscapeKeyDown maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogContent sx={{ textAlign: 'center', pt: 4, px: 4 }}>
        <Box
          sx={{
            mx: 'auto',
            mb: 2,
            width: 48,
            height: 48,
            borderRadius: '50%',
            bgcolor: 'rgba(234, 88, 12, 0.1)',
            color: '#ea580c',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <MicNoneOutlinedIcon />
        </Box>

        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary', mb: 1 }}>
          <Trans>Consultation recording and transcription</Trans>
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          <Trans>Your healthcare professional wishes to record and transcribe this consultation, with the help of AI, to prepare your medical record.</Trans>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <Trans>You may refuse and continue the consultation normally.</Trans>
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 4, pb: 4, pt: 1, gap: 1.5, flexDirection: { xs: 'column-reverse', sm: 'row' }, justifyContent: 'center' }}>
        <Button onClick={onRefuse} variant="outlined" color="inherit" fullWidth sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
          <Trans>Refuse</Trans>
        </Button>
        <Button onClick={onAccept} variant="contained" fullWidth sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
          <Trans>Accept</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  )
}
